import { Component, OnInit } from '@angular/core';
import * as Rx from 'rxjs';
import { MagliveApiClient } from "src/lib/api-client/maglive-api-client";
import { tap } from "rxjs/operators";
import { MagliveUser } from "src/lib/entity/user";

@Component({
  selector: 'maglive-admin-suspend-user',
  styleUrls: ['../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './suspend-user.component.scss'],
  templateUrl: './suspend-user.component.html'
})
export class SuspendUserComponent implements OnInit {

  private _suspendedUsers$: Rx.Observable<MagliveUser[] | "NOT_AUTHORIZED">;
  suspendUserId: string;

  get suspendedUsers$(): Rx.Observable<MagliveUser[] | "NOT_AUTHORIZED"> {
    return this._suspendedUsers$;
  }

  ngOnInit(): void {
    this.reloadSuspendedUser();
  }

  private reloadSuspendedUser() {
    this._suspendedUsers$ = MagliveApiClient.listSuspendedUser();
  }

  addSuspendedUser() {
    if (this.suspendUserId === null || this.suspendUserId === "" || isNaN(parseInt(this.suspendUserId, 10))) {
      console.error(this.suspendUserId);
      return; // TODO show error
    }
    MagliveApiClient.addSuspendUser(parseInt(this.suspendUserId, 10)).pipe(
      tap(_ => this.suspendUserId = "")
    ).subscribe(() => setTimeout(() => this.reloadSuspendedUser(), 500));
  }

  removeSuspendedUser(userId: number) {
    MagliveApiClient.removeSuspendUser(userId).subscribe(() => setTimeout(() => this.reloadSuspendedUser(), 500))
  }
}
